// extracted by mini-css-extract-plugin
module.exports = {"root":"filteredCount_root__1t9Hb","title":"filteredCount_title__3iPgi","count":"filteredCount_count__3d3Sy"};